export const CAREERS_PATH = '/careers'

export function isCareersPath(pathname = '') {
  return pathname === CAREERS_PATH || pathname.startsWith(`${CAREERS_PATH}/`)
}

/** Careers applications are English-only; switch site language before opening the page. */
export function ensureEnglishForCareers(language, setLanguage) {
  if (language === 'ar') {
    setLanguage('en')
  }
}
